import React, { useCallback, useEffect, useRef, useState } from 'react'

// Import State Context
import { useStateContext } from '../../context/StateContextAPI'

import { CompactLogo, RokkApp } from '../../assets'
import DotElement from '../../assets/dot-element.png'
import { NewsletterCard, NewsletterForm, PlansContainer } from '../../components'

// Import CSS file
import "./home.page.css"

// Import Material UI Elements
import useGoogleTag from '../../utils/gtag'
import { useTranslation } from 'react-i18next'


// const WebsiteBannerImg = styled.img`
//     width:100%;
// `

const Home = () => {

    // GTAG
    const gtag = process.env.REACT_APP_GOOGLE_TAG || "";
    useGoogleTag(gtag)

    const { t } = useTranslation()

    // Handling Promo Video Playback
    const [playOption, setPlayOption] = React.useState(false);
    const [mute, setMute] = React.useState(true);
    const videoRef = useRef<HTMLVideoElement>(null);
    const handlePlayback = () => {
        setPlayOption(!playOption);
        if (!playOption) videoRef?.current?.pause();
        else videoRef?.current?.play()
    }
    const handleSound = () => {
        setMute(!mute);
    }

    // Timeline checkpoint rotation
    const [activeCheckpoint, setActiveCheckpoint] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const totalCheckpoints = 3;

    const switchCheckpoint = useCallback((next: number) => {
        if (isTransitioning || next === activeCheckpoint) return;
        setIsTransitioning(true);
        setActiveCheckpoint(-1);
        setTimeout(() => {
            setActiveCheckpoint(next);
            setIsTransitioning(false);
        }, 500);
    }, [activeCheckpoint, isTransitioning]);

    useEffect(() => {
        const interval = setInterval(() => {
            const next = (activeCheckpoint === -1 ? 0 : (activeCheckpoint + 1) % totalCheckpoints);
            switchCheckpoint(next);
        }, 5000);
        return () => clearInterval(interval);
    }, [activeCheckpoint, switchCheckpoint]);

    // Set the active page as Home for the Navigation bar
    const { setActivePage } = useStateContext();
    useEffect(() => {
        setActivePage(() => "home")
        window.scrollTo(0, 0);
    }, [setActivePage])

    const newsletterCards = [
        { title: t('newsletterCards.favouriteBands'), content: t('newsletterCards.favouriteBandsDesc') },
        { title: t('newsletterCards.allStyles'), content: t('newsletterCards.allStylesDesc') },
        { title: t('newsletterCards.hifiOffline'), content: t('newsletterCards.hifiOfflineDesc') },
        { title: t('newsletterCards.importFunction'), content: t('newsletterCards.importFunctionDesc') },
    ]

    // return the functional component
    return (
        <div className="homePage">

            {/* Header section */}
            <div className="home-header-container">
                <div className="home-hero-title-wrapper">
                    <div className="head-text home-hero-title">
                        <div>
                            <span className="head-txt-off-white">{t('home.heroTitle1')}</span>
                            <span className="head-txt-primary">{t('home.heroTitle2')}</span>
                            <span className="head-txt-off-white">{t('home.heroTitle3')}</span>
                        </div>
                        <span className="head-txt-primary">{t('home.heroTitle4')}</span>
                    </div>
                </div>
                <div className="home-hero-layout">

                    {/* Left: Phone mockup */}
                    <div className="home-hero-phone">
                        <img src={RokkApp} alt="ROKK App" />
                    </div>

                    {/* Right: Accordion */}
                    <div className="home-hero-accordion">
                        {[
                            {
                                title: t('home.heroAllStyles'),
                                content: <p>{t('home.heroAllStylesDesc')}</p>
                            },
                            {
                                title: t('home.heroFairStreaming'),
                                content: (
                                    <>
                                        <p>{t('home.heroDirectSupport')}</p>
                                        <p>{t('home.heroMorePerStream')}</p>
                                        <a href="/fairness" className="home-hero-more">{t('home.heroMore')}</a>
                                    </>
                                )
                            },
                            {
                                title: t('home.heroAppFeatures'),
                                content: (
                                    <>
                                        <p>{t('home.heroHQAudio')}</p>
                                        <p>{t('home.heroOffline')}</p>
                                        <p>{t('home.heroPlaylistImport')}</p>
                                        <p>{t('home.heroRokkpedia')}</p>
                                        <a href="/rokk" className="home-hero-more">{t('home.heroMore')}</a>
                                    </>
                                )
                            }
                        ].map((item, i) => (
                            <div
                                key={i}
                                className={`hero-accordion-item ${activeCheckpoint === i ? 'hero-accordion-active' : ''}`}
                                onClick={() => switchCheckpoint(i)}
                            >
                                {activeCheckpoint === i && (
                                    <img src={DotElement} className="hero-accordion-dot" alt="" />
                                )}
                                <h2 className="hero-accordion-title">{item.title}</h2>
                                <div className="hero-accordion-content">
                                    <div className="hero-accordion-body">
                                        {item.content}
                                        <div className="hero-accordion-cta">
                                            <a href="https://services.rokk-api.com/" target="_blank" rel="noreferrer" className="hero-accordion-trial-btn">
                                                FREE TRIAL
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {/* The Screen containing Promo Video */}

            {/* <div className="screens-bg">
                <img src={ScreensBG} alt="rokk-app-screens" />
                <div className="video-wrapper">
                    <video
                        muted={mute ? true : false}
                        ref={videoRef}
                        loop
                        autoPlay
                        playsInline
                        className="promo-video"
                        onClick={handlePlayback}
                    >
                        <source src={"https://rokk.app/wp-content/uploads/2024/01/ROKK_Campaign_Launch.mp4"} type="video/mp4" />
                        {t('home.videoNotSupported')}
                    </video>
                </div>

                <div className="play-pause-icon-video-playback">
                    {
                        playOption
                            ?
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.playButton')} size="large" onClick={handlePlayback}>
                                <PlayArrow fontSize='medium' />
                            </IconButton>
                            :
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.pauseVideo')} size="large" onClick={handlePlayback}>
                                <Pause fontSize='medium' />
                            </IconButton>

                    }
                </div>

                <div className="mute-unmute-btn">
                    {
                        mute
                            ?
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.playButton')} size="large" onClick={handleSound}>
                                <VolumeOff fontSize='medium' />
                            </IconButton>
                            :
                            <IconButton style={{ color: '#ff8303', background: '#1a1a1a' }} aria-label={t('home.pauseVideo')} size="large" onClick={handleSound}>
                                <VolumeUpTwoTone fontSize='medium' />
                            </IconButton>

                    }
                </div>
            </div> */}

            {/* Plans Section */}

            <div className="pricing-section">
                <div className='pricing-section-header' style={{ textAlign: 'center' }}>
                    <span className="head-txt-primary">{t('home.plansAndPricing')}</span>
                </div>
                <div className="flex flex-dir-col gp-20">
                    <span style={{ textAlign: 'center' }}><span style={{ opacity: 0.5 }}>{t('home.plansSaveText')}</span> {t('home.plansAnnual')} <span style={{ opacity: 0.5 }}>{t('home.plansCombine')}</span> {t('home.plansDiscount')}</span>
                </div>

                <PlansContainer />
            </div>

            <div className="newsletter-and-card-section flex flex-dir-col">
                <div className="newsletter-container">
                    <div className="newsletter-section-header flex flex-dir-col">
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.subscribeTo')}</span>
                        <span className="head-txt-off-white font-sz-small">{t('newsletter.our')}
                            <span className="head-txt-primary">{t('newsletter.rokk')}</span>
                        </span>
                        <span className="head-txt-primary font-sz-small">{t('newsletter.newsletter')}</span>
                    </div>
                    <NewsletterForm />
                </div>
                <div className="flex jst-con-spc-btw flex-wrap gp-20" style={{ fontFamily: 'var(--title-font)', fontWeight: 'var(--font-main-weight)', paddingRight: '84px' }}>
                    <div className='flex aln-items-cnt gp-10'>
                        <img src={CompactLogo} style={{ width: '25px' }} alt="rokk_logo_compact" />
                        <span className="font-sz-medium">{t('home.whyJoinRokk')}</span>
                    </div>
                    <div className='pricing-section-header'>
                        <span className="head-txt-off-white">{t('home.musicStreamingAppFor')}</span>
                        <span className="head-txt-primary">{t('home.rockAndMetal')}</span>
                    </div>
                </div>
                <div className="newsletter-cards-container">
                    {newsletterCards.map((card, idx) => (
                        <NewsletterCard key={idx} obj={card} />
                    ))}
                </div>
            </div>
            <div className="download-app-container">
                <div className="pricing-section-header" style={{ textAlign: 'center' }}>
                    <span className="head-txt-off-white">{t('home.musicAnytime')}</span>
                    <span className="head-txt-off-white">{t('home.anywhere')}</span>
                </div>

                <div style={{ textAlign: 'center' }}>
                    {t('home.musicStreamingMade')}
                    {t('home.metalAndRockFans')}<div> <span style={{ color: 'var(--primary)' }}>{t('home.downloadTheApp')}</span>
                    </div>
                </div>
                <div className="download-btn">
                    <a href="https://play.google.com/store/apps/details?id=app.rokk.web" target="_blank" rel="noreferrer" className="store-badge">
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.18 2.04C3.07 2.17 3 2.38 3 2.64V21.36C3 21.62 3.07 21.83 3.18 21.96L3.23 22.01L13.77 11.47V11.36V11.25L3.23 0.71L3.18 2.04Z" fill="#2196F3"/>
                            <path d="M17.3 15L13.77 11.47V11.36V11.25L17.3 7.72L17.36 7.76L21.58 10.12C22.72 10.74 22.72 11.76 21.58 12.38L17.36 14.74L17.3 15Z" fill="#FFC107"/>
                            <path d="M17.36 14.96L13.77 11.36L3.18 21.96C3.56 22.36 4.18 22.41 4.88 22.02L17.36 14.96Z" fill="#4CAF50"/>
                            <path d="M17.36 7.76L4.88 0.7C4.18 0.31 3.56 0.36 3.18 0.76L13.77 11.36L17.36 7.76Z" fill="#F44336"/>
                        </svg>
                        <div className="store-badge-text">
                            <span className="store-badge-label">GET IT ON</span>
                            <span className="store-badge-name">Google Play</span>
                        </div>
                    </a>
                    <a href="https://apps.apple.com/de/app/rokk-streaming/id6448976457" target="_blank" rel="noreferrer" className="store-badge">
                        <svg viewBox="0 0 24 24" width="24" height="24" fill="#000" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 16.99 2.97 12.5 4.7 9.5C5.57 8 7.13 7.07 8.82 7.04C10.09 7.02 11.29 7.92 12.05 7.92C12.81 7.92 14.25 6.84 15.79 7.01C16.42 7.04 18.09 7.26 19.14 8.81C19.05 8.87 16.97 10.07 17 12.58C17.03 15.57 19.63 16.5 19.66 16.51C19.63 16.58 19.22 17.98 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"/>
                        </svg>
                        <div className="store-badge-text">
                            <span className="store-badge-label">Download on the</span>
                            <span className="store-badge-name">App Store</span>
                        </div>
                    </a>
                </div>

            </div>
        </div >
    )
}

export default Home
